/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Klaviyo trigger buttons ---
  // Any element with data-klaviyo-trigger opens the Klaviyo form/list
  // given in its data-klaviyo-list-id (set per-market in the
  // "Klaviyo trigger button" block).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaviyo-trigger]');
    if (!trigger) return;

    event.preventDefault();

    var listId = trigger.getAttribute('data-klaviyo-list-id');
    if (!listId) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', listId]);
  });

  // --- Variant selection validation ---
  // When preselectFirstVariant is off, keep ATC active and show an inline
  // error listing missing options if the user clicks without selecting all options.

  function getSectionForEl(el) {
    return el.closest('[data-section-id]') || document.body;
  }

  function getUnselectedWrappers(section) {
    var unselected = [];
    section.querySelectorAll('[data-option-position]').forEach(function(wrapper) {
      var checked = wrapper.querySelector('input[type="radio"]:checked');
      var hidden  = wrapper.querySelector('input[type="hidden"][data-single-option-selector]');
      var hasValue = checked || (hidden && hidden.value && hidden.value !== '');
      if (!hasValue) unselected.push(wrapper);
    });
    return unselected;
  }

  function showOptionError(wrapper) {
    var nameEl = wrapper.querySelector('.radio__legend__option-name');
    var name = nameEl ? nameEl.textContent.trim() : 'option';

    var errorEl = wrapper.querySelector('.variant-select-error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'variant-select-error';
      var legend = wrapper.querySelector('legend');
      if (legend) {
        legend.after(errorEl);
      } else {
        wrapper.prepend(errorEl);
      }
    }

    errorEl.textContent = 'Please select a ' + name;
    errorEl.removeAttribute('hidden');
  }

  function clearOptionError(wrapper) {
    var errorEl = wrapper.querySelector('.variant-select-error');
    if (errorEl) errorEl.setAttribute('hidden', '');
  }

  function triggerUnselectedErrors(section) {
    var unselected = getUnselectedWrappers(section);
    if (!unselected.length) return false;

    unselected.forEach(function(wrapper) {
      showOptionError(wrapper);
      var radioButtons = wrapper.querySelector('.radio__buttons');
      if (radioButtons) {
        radioButtons.classList.remove('variant-option-shake');
        void radioButtons.offsetWidth;
        radioButtons.classList.add('variant-option-shake');
        radioButtons.addEventListener('animationend', function() {
          radioButtons.classList.remove('variant-option-shake');
        }, { once: true });
      }
    });
    return true;
  }

  // Intercept ATC and Notify Me clicks before theme handlers fire
  document.addEventListener('click', function(e) {
    if (window.theme && window.theme.settings && window.theme.settings.preselectFirstVariant) return;

    var btn = e.target.closest('[data-add-to-cart]');
    var notifyBtn = !btn && e.target.closest('.product-soldout-notification [data-popup-open]');

    if (!btn && !notifyBtn) return;

    var section = getSectionForEl(btn || notifyBtn);
    var hadErrors = triggerUnselectedErrors(section);

    if (hadErrors) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Clear per-group error as soon as the user selects that option
  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-single-option-selector]')) return;
    var wrapper = e.target.closest('[data-option-position]');
    if (wrapper) clearOptionError(wrapper);
  });

  // --- Price fallback ---
  // When preselect is off, the Liquid renders the correct initial price
  // (first available variant) but theme JS overwrites it with 0,00 because
  // no variant is selected. Capture the Liquid price immediately and restore
  // it whenever JS overwrites it before the customer has made a selection.
  // Once all options are selected, JS takes over and updates normally.

  if (!(window.theme && window.theme.settings && window.theme.settings.preselectFirstVariant)) {
    var initialPrices = new Map();

    // Read prices from Liquid-rendered data attribute (immune to JS timing)
    var priceEls = document.querySelectorAll('[data-product-price][data-initial-price]');
    priceEls.forEach(function(el) {
      var val = el.dataset.initialPrice;
      initialPrices.set(el, val);
    });

    function hasAllOptionsSelected(el) {
      var section = el.closest('[data-section-id]') || document.body;
      var wrappers = section.querySelectorAll('[data-option-position]');
      if (wrappers.length === 0) return true; // single-variant product, always selected
      for (var i = 0; i < wrappers.length; i++) {
        var checked = wrappers[i].querySelector('input[type="radio"]:checked');
        var hidden  = wrappers[i].querySelector('input[type="hidden"][data-single-option-selector]');
        var hasValue = checked || (hidden && hidden.value && hidden.value !== '');
        if (!hasValue) return false;
      }
      return true;
    }

    function restoreIfNoVariant(el, savedHtml) {
      if (!hasAllOptionsSelected(el)) {
        el.innerHTML = savedHtml;
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      initialPrices.forEach(function(html, el) {
        restoreIfNoVariant(el, html);
      });

      initialPrices.forEach(function(html, el) {
        var observer = new MutationObserver(function() {
          observer.disconnect();
          restoreIfNoVariant(el, html);
          observer.observe(el, { childList: true, subtree: true, characterData: true });
        });
        observer.observe(el, { childList: true, subtree: true, characterData: true });
      });
    });
  }

  // --- PLP size/option availability filter fix ---
  // Shopify's native collection filters only check whether a product HAS an
  // option value (e.g. size M) as a variant, not whether that variant is
  // currently in stock (filter_value.count counts presence, not stock).
  // That let products with a sold-out M show up under a "Size: M" filter,
  // even though the PDP correctly shows M as unavailable. Each product card
  // now carries the option values it actually has in-stock variants for
  // (see data-available-option-values in product-grid-item-new.liquid),
  // and this hides cards from the grid when they only match an active
  // option filter because of a sold-out variant. Re-runs whenever the theme
  // swaps in a new grid after an AJAX filter update.
  (function () {
    function getActiveOptionFilterGroups(container) {
      var form = container.querySelector('[data-collection-filters-form]');
      if (!form) return {};

      // Read the visible label (e.g. "M"), not the checkbox value: Shopify's
      // "filter value groups" merge related option values under one
      // checkbox whose value is a synthetic gid://shopify/FilterSettingGroup/…
      // id rather than the literal option text, so matching on value would
      // never line up with product option values.
      // Grouped by filter name (e.g. filter.v.option.size) so multiple
      // checked values in the SAME group (Size: M + L) are OR'd together,
      // matching Shopify's own multi-select-within-a-group behaviour —
      // only different groups (Size + Color) are AND'd against each other.
      //
      // Covers both filter families Shopify emits for "list" filters:
      // filter.v.option.* (variant options, e.g. size) and filter.v.t.*
      // (standard taxonomy attributes, e.g. filter.v.t.shopify.color-pattern).
      var checked = form.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]:checked, input[type="checkbox"][name^="filter.v.t."]:checked');
      var groups = {};
      checked.forEach(function (input) {
        if (!input.dataset.filterValueLabel) return;
        var key = input.name;
        if (!groups[key]) groups[key] = [];
        groups[key].push(input.dataset.filterValueLabel);
      });
      return groups;
    }

    function applyAvailabilityFilter(grid) {
      var container = grid.closest('.collection__products') || document;
      var groups = getActiveOptionFilterGroups(container);
      var groupKeys = Object.keys(groups);

      grid.querySelectorAll('[data-grid-item]').forEach(function (item) {
        if (!groupKeys.length) {
          item.removeAttribute('data-hidden-unavailable');
          item.style.removeProperty('display');
          return;
        }

        var available = (item.dataset.availableOptionValues || '').split('||').filter(Boolean);
        var matchesAllGroups = groupKeys.every(function (key) {
          // Taxonomy filters (filter.v.t.*, e.g. filter.v.t.shopify.color-pattern)
          // are a product-level categorization, not a variant option value —
          // their label has no reason to appear in a variant's option values,
          // so there's no specific value to match against. The only thing we
          // can correctly check is whether the product has ANY purchasable
          // variant at all (available.length > 0 iff at least one variant.available).
          if (key.indexOf('filter.v.t.') === 0) {
            return available.length > 0;
          }

          return groups[key].some(function (value) {
            return available.indexOf(value) !== -1;
          });
        });

        if (matchesAllGroups) {
          item.removeAttribute('data-hidden-unavailable');
          item.style.removeProperty('display');
        } else {
          item.setAttribute('data-hidden-unavailable', '');
          item.style.display = 'none';
        }
      });
    }

    // Values that appear (in stock) on ANY currently loaded product card,
    // across all option types. Flat/untyped like data-available-option-values
    // itself, so this inherits the same rare cross-option label-collision
    // caveat noted above.
    function getAvailableLabels(grid) {
      var labels = {};
      grid.querySelectorAll('[data-grid-item]').forEach(function (item) {
        (item.dataset.availableOptionValues || '').split('||').filter(Boolean).forEach(function (value) {
          labels[value] = true;
        });
      });
      return labels;
    }

    // Server-side disabled/struck-through means "doesn't exist in this
    // collection" (filter_value.count == 0). This adds the same struck-out
    // treatment for the "exists, but every matching product is sold out"
    // case, which the server-computed count can't distinguish on its own.
    //
    // Only safe to do when the grid currently on screen IS the full result
    // set — getAvailableLabels only sees loaded product cards, so on a
    // paginated (multi-page) result it would falsely mark a size sold out
    // just because its in-stock products happen to be on another page.
    // .pagination-custom only renders when there's more than one page
    // (snippets/pagination.liquid), so its absence here confirms nothing
    // is hiding on a later page.
    function markSoldOutFilterOptions(grid) {
      if (grid.querySelector('.pagination-custom')) return;

      var container = grid.closest('.collection__products') || document;
      var form = container.querySelector('[data-collection-filters-form]');
      if (!form) return;

      var availableLabels = getAvailableLabels(grid);

      // Deliberately excludes filter.v.t.* taxonomy filters: their label is a
      // product-level category, not a variant option value, so there's no
      // reliable way to tell whether a SPECIFIC taxonomy value is sold out
      // from variant option data alone (see applyAvailabilityFilter above).
      form.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]').forEach(function (input) {
        if (input.disabled || input.checked) return;

        var label = input.dataset.filterValueLabel;
        if (!label || availableLabels[label]) return;

        input.disabled = true;
        var listItem = input.closest('.sidebar__item');
        if (listItem) {
          listItem.classList.remove('link--add');
          listItem.classList.add('link--disable');
        }
      });
    }

    function watchGrid(grid) {
      applyAvailabilityFilter(grid);
      markSoldOutFilterOptions(grid);

      var observer = new MutationObserver(function () {
        applyAvailabilityFilter(grid);
        markSoldOutFilterOptions(grid);
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-products-grid]').forEach(watchGrid);
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
